import script from "./ChangeFile.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeFile.vue?vue&type=script&setup=true&lang=js"

import "./ChangeFile.vue?vue&type=style&index=0&id=fa09ca80&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa09ca80"]])

export default __exports__